import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  dataContainer: {
    flex: 1,
    gap: '8px'
  },
  iconsContainer: {
    flex: 0,
    gap: '4px',
    display: 'flex',
    '& svg': {
      transition: 'color 0.2s ease-in-out'
    },
    '&[data-warn="true"]': {
      '& svg': {
        color: '#ffa000 !important'
      }
    },
    '&[data-error="true"]': {
      '& svg': {
        color: '#be1224 !important'
      }
    }
  },
  title: {
    width: '80%',
    overflow: 'hidden',
    textoOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}));
